import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Divider,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { usePermissions } from 'react-admin';

import CaseSummary from './CaseSummary';
import CaseTimeline from './CaseTimeline';
import hasAccess from '../../../utilities/hasAccess';
import actions, { Actions } from '../../../constants/actions';

const CaseSummaryTimelineCard = ({
  isSidebarClosed,
  sideBarWidth,
}: {
  isSidebarClosed: boolean;
  sideBarWidth: number;
}) => {
  const { permissions } = usePermissions<Actions[]>();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const canSeeSummary = hasAccess(permissions, actions.CASE_SUMMARY_CREATE);
  const canSeeTimeline = hasAccess(permissions, actions.CASE_GET_STATUS_BREAKDOWN);

  return (
    <Card variant="outlined">
      <CardContent>
        {canSeeSummary && (
          <Box sx={!isSmallScreen ? { maxWidth: isSidebarClosed ? '50%' : `calc((100% - ${sideBarWidth}px) / 2 + 300px)` } : {}}>
            <CaseSummary />
          </Box>
        )}
        {canSeeSummary && canSeeTimeline && <Divider sx={{ marginY: 4 }} />}
        {canSeeTimeline && <CaseTimeline />}
      </CardContent>
    </Card>
  );
};

export default CaseSummaryTimelineCard;
